import { Field, Section, inputCls } from "@/components/admin/SettingsFields";

const MODES = [["none", "Nie pokazuj"], ["mysql", "Z bazy MySQL"], ["url", "Własny adres URL"]];

const ModeButton = ({ mode, label, active, onPick }) => (
  <button type="button" onClick={() => onPick(mode)} data-testid={`players-mode-${mode}`}
    className={`px-4 py-2 rounded text-sm border transition-colors ${active ? "border-amber-400 text-amber-200 bg-amber-500/10" : "border-white/10 text-slate-400 hover:border-white/30"}`}>{label}</button>
);

export default function PlayersSection({ s, set }) {
  return (
    <Section title="Gracze online">
      <div className="flex flex-wrap gap-2">
        {MODES.map(([k, l]) => <ModeButton key={k} mode={k} label={l} active={s.players_mode === k} onPick={(m) => set({ ...s, players_mode: m })} />)}
      </div>
      {s.players_mode === "mysql" && (
        <label className="block">
          <span className="text-xs tracking-widest text-slate-500">Zapytanie SQL (zwraca jedną liczbę)</span>
          <textarea value={s.players_query} onChange={(e) => set({ ...s, players_query: e.target.value })} data-testid="settings-players_query-input" className={`${inputCls} h-20 resize-none`} />
        </label>
      )}
      {s.players_mode === "url" && (
        <>
          <Field k="players_url" l="Adres URL" t="text" s={s} set={set} />
          <p className="text-xs text-slate-600">Adres ma zwracać samą liczbę (np. <span className="font-mono">152</span>) albo JSON <span className="font-mono">{"{\"online\": 152}"}</span>.</p>
        </>
      )}
    </Section>
  );
}
